import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/common/Navbar";
import ContactBanner from "../../assets/images/banner/ring.jpg";
import BannerSection from "../../components/common/BannerSection";
import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet";

const TermsCondition = () => {
    useEffect(() => window.scrollTo(0, 0), []);
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref6, inView6] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <Helmet><title>Terms and Condition</title></Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={"Terms and Condition"}
                subtitle={"You agree to use our services only for lawful purposes"}
            />
            <div className="site-content">
                <section className="space-pt z-index-2">
                    <div className="container">
                        <div className="pb-4 privacy-poly">
                            <h1 className="privacy-header">Terms and Condition for Maa vaishno jewellers</h1>
                            <p class="policy-text">
                                Welcome to Maavaishno Jewellers. By accessing or using our website https://www.maavaishnojewellers.in/, you agree to comply with and be bound by the following terms and conditions.
                            </p>
                        </div>
                        <div className="pb-4">
                            <h3 className="privacy-header">1. General</h3>
                            <p>This website is owned and operated by Maavaishno Jewellers. The content of this website is for general information and use only and is subject to change without notice.</p>

                            <h3 className="privacy-header">2. Product Information</h3>

                            <p> We strive to ensure that all product details, descriptions, and prices are accurate. However:</p>
                            <ul>
                                <li>Slight variations may occur in jewellery due to handcrafted nature</li>
                                <li>Images are for representation purposes only</li>
                                <li>Prices are subject to change without prior notice</li>
                            </ul>
                            <h3 className="privacy-header">3. Pricing & Payments</h3>
                            <ul>
                                <li>All prices are listed in INR (₹)</li>
                                <li>We reserve the right to modify prices at any time</li>
                                <li>Payments must be made through approved payment methods available on the website</li>
                            </ul>
                            <h3 className="privacy-header">4. Order Acceptance</h3>
                            <ul>
                                <li>We reserve the right to accept or reject any order</li>
                                <li>Orders may be cancelled due to pricing errors, stock issues, or suspicious activity</li>
                            </ul>
                            <h3 className="privacy-header">5. Shipping & Delivery</h3>
                            <ul>
                                <li>Delivery timelines are estimates and may vary</li>
                                <li>Delays may occur due to unforeseen circumstances</li>
                                <li>Shipping charges (if applicable) will be displayed during checkout</li>
                            </ul>
                            <h3 className="privacy-header">6. Returns & Refunds</h3>
                            <ul>
                                <li>Returns are subject to our return policy</li>
                                <li>Customized or personalized jewellery may not be eligible for return</li>
                                <li>Refund timelines may vary based on payment method</li>
                            </ul>
                            <h3 className="privacy-header">7. Intellectual Property</h3>

                            <p> All content on this website including images, text, logo, and design is the property of Maavaishno Jewellers and protected by applicable laws.</p>

                            <h3 className="privacy-header">8. User Conduct</h3>

                            <p>You agree not to:</p>
                            <ul>
                                <li>Use the website for unlawful purposes</li>
                                <li>Upload harmful or malicious content</li>
                                <li>Attempt unauthorized access to our systems</li>
                            </ul>
                            <h3 className="privacy-header">9. Limitation of Liability</h3>

                            <p>Maavaishno Jewellers shall not be liable for any indirect or consequential damages arising from the use of this website.</p>

                            <h3 className="privacy-header">10. Governing Law</h3>

                            <p>These terms shall be governed by and interpreted in accordance with the laws of India.</p>

                            <h3 className="privacy-header">11. Contact Information</h3>

                            <p>For any queries, please contact us:</p>
                            Email: <a href="mailto:maavaishnoojewellers@gmail.com" style={{ color: "#efd7a9" }}>maavaishnoojewellers@gmail.com</a>
                            <br />  Phone: <a href="mailto:+917011967851" style={{ color: "#efd7a9" }}>+91 70119 67851</a>
                            <br /> Address: Ward No 24, Lal Bazar, Bettiah, West Champaran, Bihar, 845438
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default TermsCondition;
